<template>
  <div class="ui segment">
    <h4 class="ui header">Scheduling Information</h4>
    <div class="ui form">
      <div class="fields">
        <div class="eight wide field">
          <label>Pickup Date</label>
          <div class="ui left icon input">
            <input type="text" id="date" name="date" :v-model="date" placeholder="Pickup Date/Time">
            <i class="calendar alternate outline icon"></i>
          </div>
        </div>
        <div class="eight wide field">
          <label>Pickup Time</label>
          <div class="ui left icon input">
            <input type="text" id="time" name="time" placeholder="Pickup Date/Time">
            <i class="clock outline icon"></i>
          </div>
        </div>
      </div>
      <div v-if="showError()" class="ui red message">
        <p>Pickup time must be at least 4 hours from now to use our online booking. Please email <a href="mailto:reservations@acestowncarservice.com">reservations@acestowncarservice.com</a> and we will work to get you scheduled for service.</p>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  Vue.use(require('vue-moment'))

  export default {
    name: 'DateTime',
    props: ['auth', 'authenticated'],
    data: function () {
      return {
        date: '',
        time: '',
        dateTime: '',
        present: false,
        valid: false,
        complete: false
      }
    },
    methods: {
      showError: function () {
        return this.present && !this.valid
      },
      checkForComplete: function () {
        this.present = false
        this.valid = false
        this.complete = false

        if (this.date !== '' && this.time !== '') {
          this.present = true
          var momentDateTime = this.getMomentDateTime()
          var now = this.$moment().add(4, 'hours')
          if (momentDateTime > now) {
            this.valid = true
          }
        }

        this.complete = this.present && this.valid
        this.$emit('dateTimeComplete', { complete: this.complete, dateTime: this.date + ' ' + this.time })
      },
      getMomentDateTime: function () {
        // var timeExp = /(\d+):(\d+) ([AP]M)/
        // var dateExp = /(\d+)-(\d+)-(\d+)/

        // var timeComponents = timeExp.exec(this.time)
        // var dateComponents = dateExp.exec(this.date)

        // var amPm = timeComponents[3]
        // var hour = timeComponents[1]
        // if (amPm === 'PM' && hour !== '12') {
        //   hour = (parseInt(timeComponents[1]) + 12)
        // } else if (amPm === 'AM' && hour === 12) {
        //   hour = '00'
        // } else {
        //   hour = timeComponents[1]
        // }
        // var minute = timeComponents[2]

        // var month = dateComponents[1]
        // var day = dateComponents[2]
        // var year = dateComponents[3]

        // var validDateString = year + '-' + month + '-' + day + 'T' + hour + ':' + minute + ':00-0800'
        return this.$moment(this.date + ' ' + this.time)
      }
    },
    mounted: function () {
      var v = this
      var dateScript = function (currentDate, topDate) {
        $('#date').mobiscroll().calendar({
          onClose: function (t, i) {
            v.date = t
            v.checkForComplete()
          },
          mode: 'scroller',
          display: 'modal',
          minDate: currentDate,
          maxDate: topDate,
          dateOrder: 'M D dd yy',
          dateFormat: 'M dd, yy',
          timeFormat: 'h:mm A' })
        $('#time').mobiscroll().time({
          onClose: function (t, i) {
            v.time = t
            v.checkForComplete()
          },
          mode: 'clicker',
          display: 'modal',
          stepMinute: 5 })
      }

      $(function () {
        var currentDate = new Date()
        var topDate = new Date()
        currentDate.setHours(currentDate.getHours() - 24)
        topDate.setMonth(topDate.getMonth() + 11)
        dateScript(currentDate, topDate)
      })
    }
  }
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/DateTime.vue